export default {
  common: {
    chiller: "Kühlaggregat",
    chilledWaterPump: "Kühlwasserpumpe",
    coolingTower: "Kühlturm",
    nextStep: "Nächster Schritt",
    previousStep: "Vorheriger Schritt",
    objective: "Ziel",
    preRetrofit: "Vor der Nachrüstung",
    postRetrofit: "Nach der Nachrüstung",
    retrofitSetup: "Nachrüst-Setup",
    equipmentRated: "Gerätebewertung",
    retrofitSummary: "Zusammenfassung der Nachrüstung",
    cwp: "CWP",
    condenderWaterPump: "Kondensatorwasserpumpe",
    chwp: "CHWP",
    ct: "CT",
    other: "Sonstige",
    otherEquipment: "Weitere Geräte",
    chillerOneNos: "Kühlaggregat (1 Stk.)",
    condenderWaterPumpOneNos: "Kondensatorwasserpumpe (1 Stk.)",
    chilledWaterPumpOneNos: "Kühlwasserpumpe (1 Stk.)",
    coolingTowerFanOneNos: "Kühlturm (1 Stk.)",
    dryCooler: "Trocken-Kühler",
    controlOptimization: "Steuerungsoptimierung",
    commonHeader: "Allgemeiner Header",
    dedicatedOneOnOne: "Dediziert (1-1)",
    pleaseInput: "Bitte eingeben",
    pleaseEnterHere: "Bitte hier eingeben",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    years: "Jahre",
    noProjectInfo: "Keine Projektinformationen",

    pleaseInputData: "Bitte geben Sie Daten ein",
    systemOptionRequired: "Systemoption ist erforderlich",
    proposedEquipmentRequired: "Vorgeschlagene Ausrüstung ist erforderlich"
  },
  objective: {
    projectObjective: "Projektziel",
    chillerEfficiency: "Kühlaggregat-Effizienz",
    chillerPlantEfficiency: "Effizienz der Kühlanlagen",
    heatingEfficiency: "Heizeffizienz",
    heatingPlantEfficiency: "Effizienz der Heizungsanlagen",
    chillerHeatingEfficiency: "Effizienz der Kühlheizung",
    pleaseSelectAProjectObjective: "Bitte wählen Sie ein Projektziel aus",
    oneOnOne: "(1 - 1)",
    oneOnOneOrPlant: "(1 - 1) oder Anlage",
    projectName: "Projektname",
    doYouWantSave: "Möchten Sie Ihre Daten vor dem Schließen in die Cloud speichern?",
    start: "Start",
    quickNavigation: "Schnellnavigation",

    establishBaseline: "Grundlinie festlegen",
    profile: "Profil",
    siteObservation: "Standortbeobachtung",
    equipmentSpecification: "Spezifikation der Ausrüstung",
    baselineInput: "Baseline input",
    summary: "Zusammenfassung",
    generateReport: "Bericht erstellen",

    finalizeYourProposal: "Finalisieren Sie Ihren Vorschlag",
    retrofitSetup: "Nachrüstung",
    equipmentRated: "Ausrüstung bewertet",
    financialAnalysis: "Finanzanalyse",
    proposedConfig: "Vorgeschlagene Konfiguration"
  },
  setup: {
    systemOption: "Systemoption",
    chillerOnly: "Nur Kühlaggregat",
    chillerWithAssociatedEquipment: "Kühlaggregat mit zugehörigen Geräten",
    controlOnly: "Nur Steuerung",
    proposedLayout: "Vorgeschlagenes Layout",
    series: "Serie",
    parallel: "Parallel",
    proposedEquipment: "Vorgeschlagene Geräte"
  },
  rated: {
    newEquipment: "Neue Geräte",
    ratedInputPower: "Nennanschlussleistung",
    ratedCoolingCapacity: "Nennkühlleistung",
    chillerLabel: "Kühlaggregat-Beschriftung",
    type: "Typ",
    chillerBrandModel: "Marke & Modell des Kühlaggregats",
    yearInstalled: "Baujahr",
    ratedDesignFlowRate: "Nenn-Design-Durchflussrate",
    pressureHead: "Druckhöhe",
    vfd: "Ist ein Frequenzumrichter installiert",
    yes: "Ja",
    no: "Nein",
    noofFansCT: "Anzahl der Ventilatoren/CT",
    equipmentLabel: "Gerätebeschriftung",
    category: "Kategorie",
    brand: "Marke",
    otherEquipment: "Andere Geräte",
    inputEcatPerformanceData: "Eingabe Ecat-Leistungsdaten",
    load: "Last",
    coolingLoad: "Kühlbedarf",
    inputPower: "Energieverbrauch",
    chillerWaterPumpLabel: "Kühlwasserpumpen-Beschriftung",
    ratedMotorFrequency: "Nennmotorfrequenz",
    minimumMotorFrequency: "Minimale Motorfrequenz",
    motor: "Motor",
    applicableChiller: "Gültiges Kühlaggregat",
    condenserWaterPumpLabel: "Kondensatorwasserpumpen-Beschriftung",
    coolingTowerLabel: "Kühlturm-Beschriftung",
    ratedFanFrequency: "Nennventilatorfrequenz",
    minimumFanFrequency: "Minimale Ventilatorfrequenz",
    totalRatedFanPowerPerCT: "Gesamt-Nennleistung der Ventilatoren pro CT",
    heatRejectionCapacityPerCT: "Wärmeabfuhrkapazität pro CT",
    chillerLabelRequired: "Kühlaggregat-Beschriftung erforderlich",
    yellowBlockRequired: "Das gelbe Feld ist erforderlich",
    labelRequired: "Beschriftung erforderlich",
    maximumQuantity: "Maximale Menge"
  },
  summary: {
    chooleYourPreference: "Wählen Sie Ihre Präferenz",
    higherEfficiencyImprovement: "Höhere Effizienzsteigerung",
    lowerInvestment: "Niedrigere Investition",
    higherCostSaving: "Höhere Kosteneinsparungen",
    shorterPaybackPeriod: "Kürzere Amortisationszeit",
    option: "Option",
    efficiencyImprovement: "Effizienzsteigerung",
    returnOnInvestment: "Rendite",
    costSavingsPerYear: "Kosteneinsparungen pro Jahr",
    paybackPeriod: "Amortisationszeit",
    optionDetails: "Optionsdetails",
    postRetrofitEfficiency: "Nachrüst-Effizienz",
    totalEnergySavingsPerYear: "Jährliche Energieeinsparungen insgesamt",
    investmentAnalysis: "Investitionsanalyse",
    capex: "CAPEX",
    sellingPrice: "Verkaufspreis",
    chillerCooling: "Kühlaggregat-Kühlung",
    chilledHeatPump: "Kühl-Wärmepumpe",
    calculate: "Berechnen",
    proposedConfig: "Vorgeschlagene Konfiguration",
    projectIntroduction: "Projektbeschreibung",
    assumptions: "Annahmen",
    chillerPlant: "Kühlaggregatanlage",
    chillerPlantConfig: "Konfiguration der Kühlaggregatanlage",
    peakBuildingCoolingLoad: "Spitzenwärmebedarf des Gebäudes",
    designChilledWaterSupplyTemp: "Design-Kühlwassertemperatur",
    designCondenserWaterSupplyTemp: "Design-Kondensatorwassertemperatur",
    energyConservationMeasures: "Energieeinsparmaßnahmen",
    pumpingConfig: "Pumpenkonfiguration",
    designFlowRate: "Design-Durchflussrate",
    designPressureHead: "Design-Druckhöhe",
    vfdFitted: "VFD installiert",
    chillerConfig: "Kühlaggregat-Konfiguration",
    condenserWaterPump: "Kondensatorwasserpumpe",
    coolingTowerConfig: "Kühlturm-Konfiguration",
    heatRejectionCapacity: "Wärmeabfuhrkapazität",
    designCoolingTowerApproach: "Design-Kühlturm-Anäherung",
    generateReport: "Bericht erstellen",
    confirmCalculation: "Berechnung bestätigen",
    doYouNeedCalculationAgain: "Das Berechnungsergebnis liegt bereits vor. Möchten Sie erneut berechnen?",
    recalculate: "Erneut berechnen",
    coolingTower: "Kühlturm",
    chiller: "Kühlaggregat",
    chilledWaterPump: "Kühlwasserpumpe",
    fillValidNumericalValue: "Bitte geben Sie einen gültigen Zahlenwert ein"
  },
  profileMap: {
    associatedChiller: "Kartierung von Kaltmaschinen",
    associatedCT: "Abbildung des Kühlturms",
    associatedCWP: "Abbildung CWP",
    associatedCHWP: "Abbildung CHWP",
    profileId: "Profil-ID",
    donotNeedmanipulate: "Im automatischen Modus müssen Sie keine Profile bearbeiten.",

    automatic: "Automatisch",
    manual: "Manuell",
    pathAndMethod: "Wegweisenmethode",
    months: "Monate",
    running: "Laufen",
    daysPerMonth: "Tage im Monat",
    chiller: "Kühler"
  }
}



// WEBPACK FOOTER //
// ./src/locale/post/de.js